import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import JunzuGame from './JunzuGame';
import Privacy from './Privacy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<JunzuGame />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </Router>
  );
}

export default App;
